<template>
  <main-content with_go_back_bar>
    <kt-panel>
      <div class="create-services">
          <router-link to="/factors" class="mr-2">
            <button class="btn btn-success">بازگشت</button>
          </router-link>
      </div>
        <div>
            <ul class="nav nav-tabs m-0 p-0 mx-2" role="tablist">
                <li>
                    <button @click="changeTab('factor-detail')" :class="['nav-link', tab == 'factor-detail' ? 'active': '']"
                            data-toggle="tab"
                            role="tab" aria-selected="false"
                            style="cursor:pointer;"
                            type="button"
                    >
                        جزئیات فاکتور
                    </button>
                </li>
                <li v-if="detailFactor.type == 3">
                    <button @click="changeTab('transaction-list')" :class="['nav-link', tab == 'transaction-list' ? 'active': '']"
                            data-toggle="tab"
                            role="tab" aria-selected="false"
                            style="cursor:pointer;"
                            type="button"
                    >
                        لیست تراکنش های فاکتور
                    </button>
                </li>
                <li v-if="detailFactor.type == 3">
                  <button @click="changeTab('transaction-excel-list')" :class="['nav-link', tab == 'transaction-excel-list' ? 'active': '']"
                          data-toggle="tab"
                          role="tab" aria-selected="false"
                          style="cursor:pointer;"
                          type="button"
                  >
                    لیست اکسل تراکنش های فاکتور
                  </button>
                </li>
            </ul>

            <div class="tab-content">
                <div :class="['tab-pane', tab == 'factor-detail' ? 'active':'']" id="factor-detail">
                    <form
                        @submit.prevent="submitRequest($event, query)"
                        id="single-request-form"
                        class="kt-form p-3 my-4"
                    >
                        <div
                            class="container p-3 pt-5 my-4 border in-border-header"
                            style="padding-top: 1.5rem !important"
                        >
                            <kt-form-section is_first>
                                <div class="section-header bg-white">
                                    {{ "جزئیات فاکتور" }}
                                </div>
                                <kt-row class="p-2">
                                    <!-- Details Factor -->
                                    <div class="col-md-12">
                                        <h4 class="text-center font-weight-bold bg-white">
                                            {{ detailFactor.title }}
                                        </h4>
                                    </div>
                                    <div class="col-12 my-3 d-flex justify-content-between">
                                        <div>
                                            <h5 class="router-link-white">تاریخ صدور فاکتور</h5>
                                            <p class="font-weight-normal router-link-white">
                                                {{ detailFactor.created_at }}
                                            </p>
                                        </div>
                                        <div class="ml-5">
                                            <h5 class="router-link-white">شماره فاکتور</h5>
                                            <p class="font-weight-normal router-link-white" v-if="detailFactor.code != null">
                                                {{ detailFactor.code }}
                                            </p>
                                            <p class="font-weight-normal router-link-white" v-else>______</p>
                                        </div>
                                    </div>
                                </kt-row>
                                <!--Format-->
                                <kt-row>
                                    <div v-if="detailFactor.format" class="mb-5 mt-3 mx-4 w-100">
                                        <!--String-->
                                        <div  class="mb-3 d-flex flex-wrap">
                                            <StringInput
                                                v-if="string_fields.length > 0"
                                                v-for="field in string_fields"
                                                :key="field.id"
                                                :field="field"
                                            />
                                            <NumericInput
                                                v-if="numeric_fields.length > 0"
                                                v-for="field in numeric_fields"
                                                :key="field.id"
                                                :field="field"
                                            />
                                            <DateInput
                                                v-if="date_fields.length > 0"
                                                v-for="field in date_fields"
                                                :key="field.id"
                                                :field="field"
                                            />
                                            <SelectInput
                                                v-if="select_fields.length > 0"
                                                v-for="field in select_fields"
                                                :key="field.id"
                                                :field="field"
                                            />
                                            <TextInput
                                                v-if="text_fields.length > 0"
                                                v-for="field in text_fields"
                                                :key="field.id"
                                                :field="field"
                                            />
                                        </div>
                                    </div>
                                    <!--Customer-->
                                    <div v-if="detailFactor.customer" class="col-md-6 my-5">
                                        <h5 class="router-link-white">مشخصات مشتری</h5>
                                        <div class="d-flex justify-content-between align-items-center mt-4">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <label>نام و نام خانوادگی:</label>
                                                <p class="text-dark font-weight-normal router-link-white mx-2">
                                                    {{ detailFactor.customer.name }}
                                                </p>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <label>موبایل:</label>
                                                <p dir="ltr" class="text-dark font-weight-normal router-link-white mx-2">
                                                    {{ detailFactor.customer.mobile }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <table class="table">
                                            <thead class="thead-light text-center router-link-white">
                                            <tr>
                                                <th>آیتم</th>
                                                <th>تعداد</th>
                                                <th>مبلغ واحد</th>
                                                <th>مبلغ کل</th>
                                                <th>مجموع</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(item, idx) in detailFactor.items" :key="(item, idx)">
                                                <td>{{ item.title }}</td>
                                                <td>{{ item.number }}</td>
                                                <td>{{ item.unit_amount.toLocaleString() + " ریال" }}</td>
                                                <td>{{ item.total_amount.toLocaleString() + " ریال" }}</td>
                                                <td>{{ item.final_amount.toLocaleString() + " ریال" }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="detailFactor.type == '3' && detailFactor.discounts.length > 0" class="col-md-12 my-4">
                                        <table class="table">
                                            <thead class="thead-light text-center router-link-white">
                                            <tr>
                                                <th>کد تخفیف</th>
                                                <th>درصد تخفیف</th>
                                                <th>حداقل مبلغ خرید</th>
                                                <th>حداکثر مبلغ تخفیف</th>
                                                <th>تاریخ انقضاء</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="discount in detailFactor.discounts">
                                                <td>{{ discount.code }}</td>
                                                <td>{{ discount.discount_percent + '%' }}</td>
                                                <td>{{ Number(discount.min_purchase_amount).toLocaleString() + " ریال" }}</td>
                                                <td>{{ Number(discount.max_discount_amount).toLocaleString() + " ریال" }}</td>
                                                <td>{{ discount.expires_at || '-' }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="col-md-6">
<!--                                        <div class="bg-light p-4 my-2 dark-theme-bg-dark">-->
<!--                                            <span>پیغام قبل از پرداخت : </span>-->
<!--                                            <span>{{ detailFactor.message }}</span>-->
<!--                                        </div>-->
                                        <div class="bg-light p-4 my-4 dark-theme-bg-dark">
                                            <p>
                                                <span class="router-link-white">فرآیند بعد از پرداخت - </span>
                                                <span class="router-link-white" v-if="detailFactor.rule_type == 1">نمایش رسید</span>
                                                <span class="router-link-white" v-if="detailFactor.rule_type == 2">ریدایکت به لینک </span>
                                            </p>
                                            <span class="router-link-white" v-if="detailFactor.rules" v-html="detailFactor.rules"></span>
                                        </div>
                                        <div class="d-flex justify-content-between w-50" v-if="detailFactor.rule_type == 1 && detailFactor.receipt_link" >
                                            <p class="router-link-white font-weight-bold mr-2">لینک رسید: </p>
                                            <a target="_blank" class="btn btn-success" :href="detailFactor.receipt_link"><span class="router-link-white">{{ detailFactor.receipt_link }}</span></a>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mt-4">
                                        <div class="d-flex align-items-start justify-content-between">
                                            <h5 class="router-link-white">قیمت کل محصولات</h5>
                                            <p class="font-weight-normal router-link-white">
                                                {{ Number(detailFactor.factor_amount).toLocaleString() + " ریال" }}
                                            </p>
                                        </div>
                                        <hr />
                                        <div class="d-flex align-items-start justify-content-between">
                                            <h5 class="router-link-white">هزینه حمل و نقل</h5>
                                            <p class="font-weight-normal router-link-white">
                                                {{ Number(detailFactor.shipping_cost).toLocaleString() + " ریال" }}
                                            </p>
                                        </div>
                                        <hr v-if="detailFactor.type != '3'" />
                                        <div v-if="detailFactor.type != '3'" class="d-flex align-items-start justify-content-between">
                                            <h5 class="router-link-white">مجموع تخفیف</h5>
                                            <p class="font-weight-normal router-link-white">
                                                {{
                                                    Number(detailFactor.factor_discount_amount).toLocaleString() +
                                                    " ریال"
                                                }}
                                            </p>
                                        </div>
                                        <hr v-if="detailFactor.wage != 0" />
                                        <div v-if="detailFactor.wage != 0" class="d-flex align-items-start justify-content-between">
                                            <h5 class="router-link-white">کارمزد درگاه بانکی</h5>
                                            <p class="font-weight-normal router-link-white">
                                                {{
                                                    Number(detailFactor.wage).toLocaleString() +
                                                    " ریال"
                                                }}
                                            </p>
                                        </div>
                                        <hr />
                                        <div class="d-flex align-items-start justify-content-between">
                                            <h5 class="font-weight-bold router-link-white"> مبلغ قابل پرداخت (با احتساب مالیات)</h5>
                                            <p class="text-primary font-weight-bold router-link-white">
                                                {{
                                                    Number(detailFactor.payment_amount).toLocaleString() + " ریال"
                                                }}
                                            </p>
                                        </div>
                                    </div>
                                    <div
                                        style="border-bottom: 1px solid #eee; padding: 1rem"
                                        class="col-md-12 mb-5"
                                    ></div>
                                    <!-- TimeLine and Visited -->
                                    <div class="col-md-12">
                                        <div class="text-center text-dark my-4">
                                            <h1
                                                v-if="detailFactor.is_archived"
                                                class="alert alert-danger d-block col-md-4 mx-auto p-3"
                                            >
                                                <span class="text-white">فاکتور آرشیو است</span>
                                            </h1>
                                            <h1
                                                v-if="detailFactor.status == 0"
                                                class="alert alert-danger d-block col-md-4 mx-auto p-3"
                                            >
                                                <span class="text-white">فاکتور معلق است</span>
                                            </h1>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="accordion" id="accordionExample">
                                            <div class="card dark-theme-bg-dark">
                                                <div class="card-header" id="headingOne">
                                                    <h2 class="mb-0">
                                                        <button
                                                            class="btn btn-block text-right text-dark router-link-white"
                                                            type="button"
                                                            data-toggle="collapse"
                                                            data-target="#collapseOne"
                                                            aria-expanded="true"
                                                            aria-controls="collapseOne"
                                                        >
                                                            جزئیات
                                                        </button>
                                                    </h2>
                                                </div>

                                                <div
                                                    id="collapseOne"
                                                    class="collapse show"
                                                    aria-labelledby="headingOne"
                                                    data-parent="#accordionExample"
                                                >
                                                    <div class="card-body dark-theme-bg-dark">
                                                        <div v-if="detailFactor.simple_sent_date" class="d-flex align-items-center justify-content-between">
                                                            <p class="text-primary router-link-white">تاریخ اولین ارسال</p>
                                                            <p v-if="['1', '3'].includes(detailFactor.type)" class="router-link-white">
                                                                {{ detailFactor.simple_sent_date }}
                                                            </p>
                                                            <p v-if="detailFactor.type == '2'" class="router-link-white">
                                                                {{ detailFactor.scheduler_start_date }}
                                                            </p>
                                                        </div>
                                                        <div v-if="detailFactor.simple_due_date" class="d-flex align-items-center justify-content-between">
                                                            <p class="text-primary router-link-white">سر رسید</p>
                                                            <p v-if="['1', '3'].includes(detailFactor.type)" class="router-link-white">
                                                                {{ detailFactor.simple_due_date }}
                                                            </p>
                                                            <p v-if="detailFactor.type == '2'" class="router-link-white">
                                                                {{ "بعد از " + detailFactor.scheduler_due_days + " روز" }}
                                                            </p>
                                                        </div>
                                                        <div
                                                            class="w-100 d-flex flex-row align-items-center justify-content-between"
                                                            v-if="detailFactor.type == '3' &&
                                detailFactor.is_archived == false &&
                                detailFactor.status == 1"
                                                        >
                                                            <h6
                                                                class="btn btn-primary text-center"
                                                            >
                                                                <router-link :to="`/invoice/${detailFactor.id}/sub-factor`" class="router-link-white"
                                                                > لینک پرداخت فاکتور اصلی
                                                                </router-link>
                                                            </h6>
                                                            <div class="border border-white" style="height: 101px">
                                                                <qrcode-vue
                                                                    :value="`${detailFactor.url}`"
                                                                    :size="size"
                                                                    level="M"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="detailFactor.type != '3'" class="card dark-theme-bg-dark" v-for="sub in detailFactor.sub_factors" :key="sub.id">
                                                <div class="card-header" id="headingTwo">
                                                    <h2 class="mb-0">
                                                        <button
                                                            class="btn btn-block collapsed text-left text-dark d-flex flex-row align-item-center justify-content-between"
                                                            type="button"
                                                            data-toggle="collapse"
                                                            :data-target="`#collapse-${sub.id}`"
                                                            aria-expanded="false"
                                                            :aria-controls="`collapse-${sub.id}`"
                                                        >
                                                            <div
                                                                class="d-flex flex-row align-items-center justify-content-center"
                                                            >
                                                                <h6 class="mr-4 router-link-white">فاکتور تاریخ {{ sub.sending_date }}</h6>
                                                                <h6
                                                                    v-if="
                                sub.cancelled_at == null &&
                                detailFactor.is_archived == false &&
                                detailFactor.status == 1
                              "
                                                                    class="btn btn-primary text-center mx-5"
                                                                >
                                                                    <router-link :to="`/invoice/${detailFactor.id}/sub-factor/${sub.id || ''}`" class="router-link-white"
                                                                    >لینک پرداخت
                                                                    </router-link>
                                                                </h6>
                                                                <h6
                                                                    class="badge badge-danger"
                                                                    v-if="sub.cancelled_at != null"
                                                                >
                                                                    فاکتور لغو شد
                                                                </h6>
                                                                <h6 class="badge badge-success" v-if="sub.paid_at">
                                                                    پرداخت شده
                                                                </h6>
                                                            </div>
                                                            <div>
                                                                <i class="fa fa-angle-down router-link-white"></i>
                                                            </div>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div
                                                    class="collapse"
                                                    :id="`collapse-${sub.id}`"
                                                    aria-labelledby="headingTwo"
                                                    data-parent="#accordionExample"
                                                >
                                                    <div class="card-body">
                                                        <div class="container">
                                                            <div class="wrapper">
                                                                <div
                                                                    class="lineView d-flex align-items-center justify-content-between"
                                                                >
                                                                    <div class="mb-5">
                                                                        <button
                                                                            class="btn btn-primary ml-3"
                                                                            type="button"
                                                                            @click="reminder(sub.id)"
                                                                            :disabled="detailFactor.is_archived == true
                                  || detailFactor.status == 0
                                  || sub.cancelled_at != null
                                  || sub.payment_status != 0"
                                                                        >
                                                                            یادآوری فاکتور
                                                                        </button>
                                                                        <button
                                                                            class="btn btn-danger"
                                                                            type="button"
                                                                            @click="cancel(sub.id)"
                                                                            v-if="sub.cancelled_at == null"
                                                                            :disabled="detailFactor.is_archived == true
                                  || detailFactor.status == 0
                                  || sub.payment_status != 0"
                                                                        >
                                                                            لغو فاکتور
                                                                        </button>
                                                                    </div>
                                                                    <div>
                                                                        <qrcode-vue
                                                                            :value="`${sub.url}`"
                                                                            :size="size"
                                                                            level="M"
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <ul
                                                                        class="font-weight-bold mt-4"
                                                                        v-if="sub.cancelled_at != null"
                                                                    >
                                                                        <div class="timeShow">
                                                                            <div class="time w-100">
                                                                                {{ sub.cancelled_at }}
                                                                            </div>
                                                                            <p class="text-timeShow mx-3">فاکتور لغو شد</p>
                                                                        </div>
                                                                    </ul>
                                                                    <ul
                                                                        class="font-weight-bold mt-4 sessions"
                                                                        v-if="sub.reminder_at != null"
                                                                    >
                                                                        <div class="timeShow">
                                                                            <div class="time w-100">
                                                                                {{ sub.reminder_at }}
                                                                                <p class="text-timeShow">فاکتور یادآوری شد</p>
                                                                            </div>
                                                                        </div>
                                                                    </ul>
                                                                </div>
                                                                <ul class="sessions">
                                                                    <li
                                                                        v-for="(timeSub, idx) in sub.visited_at"
                                                                        :key="(timeSub, idx)"
                                                                    >
                                                                        <div class="time w-100">{{ timeSub }}</div>
                                                                        <p>فاکتور مشاهد شد</p>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </kt-row>
                            </kt-form-section>
                        </div>
                    </form>
                </div>

                <div v-if="detailFactor.type == 3 && tab == 'transaction-list'"
                     :class="['tab-pane', tab == 'transaction-list' ? 'active':'']" id="transaction-list">
                    <FactorTransactionList />
                </div>

                <div v-if="detailFactor.type == 3 && tab == 'transaction-excel-list'"
                     :class="['tab-pane', tab == 'transaction-excel-list' ? 'active':'']" id="transaction-excel-list">
                  <SubFactorExcel />
                </div>
            </div>
        </div>
    </kt-panel>
  </main-content>
</template>

<script>
import $ from "jquery";
import axios from "axios";
import { ShopApiUrl } from '@/common/api.service';
import toastr from "toastr";
import { KTApp } from "@/plugins/core/app";
import { mapGetters } from "vuex";
import mainContent from "@/components/main-content";
import QrcodeVue from "qrcode.vue";
import { onlineFactorService } from "@/common/shop.service";
import { fieldTypesConstants } from '@/constants/CustomerFormatFieldType';
import StringInput from '@/views/online-factor/components/StringInput.vue';
import NumericInput from '@/views/online-factor/components/NumericInput.vue';
import TextInput from '@/views/online-factor/components/TextInput.vue';
import DateInput from '@/views/online-factor/components/DateInput.vue';
import SelectInput from '@/views/online-factor/components/SelectInput.vue';
import SubFactorExcel from '@/views/online-factor/SubFactorExcel.vue';
import FactorTransactionList from '@/views/online-factor/FactorTransactionList.vue';

export default {
  components: {
      FactorTransactionList,
    SelectInput,
    DateInput,
    TextInput,
    NumericInput,
    SubFactorExcel,
    StringInput,
    "main-content": mainContent,
    QrcodeVue,
  },
  props: {
    submitSingleRequest: {
      default: function ($event, query) {},
      type: Function,
    },
  },
  data() {
    return {
      query: {
        is_unlimited: false,
      },
      hashid: this.$route.params.hashid,
      editable: true,
      size: 100,
      message: "Copy These Text",
      tab: 'factor-detail'
    };
  },
  computed: {
    ...mapGetters("onlineFactor", ["detailFactor"]),
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false,
      };
      return toastr;
    },
    fieldTypes() {
      return fieldTypesConstants
    },
    string_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type == this.fieldTypes.STRING)
      }
    },
    numeric_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type == this.fieldTypes.NUMERIC)
      }
    },
    text_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type == this.fieldTypes.TEXT)
      }
    },
    date_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type == this.fieldTypes.DATE)
      }
    },
    select_fields() {
      if (this.detailFactor.format) {
        return this.detailFactor.format.fields.filter(item => item.type == this.fieldTypes.SELECT)
      }
    },
  },
  methods: {
    changeTab(tab) {
        this.tab = tab
    },
    submit(e, query) {
      let form = $("#single-request-form");
      let btn = $("#form-btn");

      form.validate({
        rules: {
          customer_type: {
            required: true,
          },
          real_first_name: {
            required: true,
          },
          real_last_name: {
            required: true,
          },
          mobile: {
            required: true,
          },
          email: {
            required: true,
          },
        },
      });

      if (!form.valid()) return;

      KTApp.progress(btn);

      axios({
        url: ShopApiUrl.path(`factor/${this.hashid}`),
        method: "POST",
        params: {
          customer_type: this.detailCustomer.customer_type,
          real_first_name: this.detailCustomer.real_first_name,
          real_last_name: this.detailCustomer.real_last_name,
          email: this.detailCustomer.email,
          mobile: this.detailCustomer.mobile,
          // image: this.file
        },
      })
        .then((response) => {
          this.toastr.success(response.data.message);
        })
        .catch(({ response }) => {
          this.toastr.error(response.data.message);
        })
        .finally((response) => {
          KTApp.unprogress(btn);
        });
    },
    currencyFormat(price) {
      price = Math.floor(price / 10);
      const pieces = parseFloat(price).toFixed(0).split("");
      let ii = pieces.length;

      while ((ii -= 3) > 0) {
        pieces.splice(ii, 0, ",");
      }

      return pieces.join("");
    },
    processFile(e) {
      let file = event.target.files[0];
      let output = document.getElementById("logo_preview");
      output.src = URL.createObjectURL(event.target.files[0]);
      output.onload = function () {
        URL.revokeObjectURL(output.src); // free memory
      };
    },
    doCopy() {
      this.$copyText(this.value).then((e) => {
        this.toastr.success("کپی شد");
      });
    },
    reminder(id) {
      onlineFactorService
        .remindFactor(id)
        .then((response) => {
          this.toastr.success(response.data.message);
          this.$router.go(this.$router.currentRoute);
        })
        .catch((error) => {
          throw new Error(error)
        });
    },
    cancel(id) {
      onlineFactorService
        .cancelFactor(id)
        .then((response) => {
          this.toastr.success(response.data.message);
          this.$router.go(this.$router.currentRoute);
        })
        .catch((error) => {
          throw new Error(error)
        });
    },
    printPage() {
      window.print();
    },
  },
  mounted() {
    this.$store.dispatch("onlineFactor/showFactor", this.$route.params.hashid);

  },
};
</script>
<style scoped>
.preview_img {
  max-width: 70px;
  max-height: 70px;
  position: absolute;
  top: 10px;
  left: 80px;
}

.c_pointer {
  cursor: pointer;
}


.containers {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  background: linear-gradient(45deg, #209cff, #68e0cf);
  padding: 3rem 0;
}
.wrapper {
  background: #eaf6ff;
  padding: 2rem;
  border-radius: 15px;
}
h1 {
  font-size: 1.1rem;
  font-family: sans-serif;
}
.sessions {
  margin-top: 2rem;
  border-radius: 12px;
  position: relative;
}

.timeShow {
  padding-bottom: 1.5rem;
  border-right: 1px solid #abaaed;
  position: relative;
  padding-right: 20px;
  margin-right: 10px;
  margin-bottom: -1.5rem;
}

.timeShow::after {
  content: "";
  width: 15px;
  height: 15px;
  background: white;
  border: 1px solid #4e5ed3;
  box-shadow: 3px 3px 0px #bab5f8;
  box-shadow: 3px 3px 0px #bab5f8;
  border-radius: 50%;
  position: absolute;
  right: -8px;
  top: 0px;
}

.text-timeShow {
  font-size: 12px;
  font-weight: 400;
}

.time {
  color: #2a2839;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
}
p {
  color: #4f4f4f;
  font-family: sans-serif;
  line-height: 1.5;
  margin-top: 0.4rem;
}

.btn .badge {
  margin: 0 1rem 0 0;
}

.create-services {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-end;
    }

@media screen and (max-width: 1000px) {
  .marginTopSm {
    margin: 1rem 0 0 0;
  }

  tr td {
    font-size: 10px;
  }

  table thead {
    font-size: 9px;
  }

    #overlay {
        position: fixed; /* Sit on top of the page content */
        width: 100%; /* Full width (cover the whole page) */
        height: 100%; /* Full height (cover the whole page) */
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
        z-index: 1000; /* Specify a stack order in case you're using a different order for other elements */
        cursor: pointer; /* Add a pointer on hover */
    }

    table > tbody > tr:not(:last-child) > td {
        border-bottom: 1px solid #dedede;
    }
}
</style>
